import { useEffect, useState } from 'react';

/** Campo de texto com foco = teclado virtual aberto no celular. */
const ehCampoDeTexto = (el: Element | null) =>
  !!el &&
  ((el instanceof HTMLInputElement && !['checkbox', 'radio', 'button', 'submit', 'range', 'file'].includes(el.type)) ||
    el instanceof HTMLTextAreaElement ||
    (el instanceof HTMLElement && el.isContentEditable));

/**
 * Teclado aberto: barras presas ao pe da tela subiriam junto e cobririam o campo
 * que se esta digitando. Quem usa este hook sai da frente enquanto houver um
 * campo de texto com foco.
 */
export function useTecladoAberto() {
  const [aberto, setAberto] = useState(false);
  useEffect(() => {
    const entrou = (e: FocusEvent) => setAberto(ehCampoDeTexto(e.target as Element));
    // No focusout o proximo foco ainda nao chegou: confere depois do evento.
    const saiu = () => setTimeout(() => setAberto(ehCampoDeTexto(document.activeElement)), 0);
    document.addEventListener('focusin', entrou);
    document.addEventListener('focusout', saiu);
    return () => {
      document.removeEventListener('focusin', entrou);
      document.removeEventListener('focusout', saiu);
    };
  }, []);
  return aberto;
}
